import {
  SecurityPoiModel,
  SecurityCategoryModel,
} from "../models/site-security-mapping.model";
import {
  ADD_SECURITY_POIS,
  ADD_SECURITY_CATEGORIES,
} from "../actions/site-security-mapping.action";
import { createReducer, on } from "@ngrx/store";

const INITIAL_STATE_SECURITY_POIS: SecurityPoiModel[] = [];
const INITIAL_STATE_SECURITY_CATEGORIES: SecurityCategoryModel[] = [];

export const SecurityCategoriesReducer = createReducer(
  INITIAL_STATE_SECURITY_CATEGORIES,
  on(
    ADD_SECURITY_CATEGORIES,
    (_, { securityCategories }) => securityCategories,
  ),
);

export const SecurityPoisReducer = createReducer(
  INITIAL_STATE_SECURITY_POIS,
  on(ADD_SECURITY_POIS, (_, { securityPois }) => securityPois),
);
